var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoContainer',_vm._b({},'VideoContainer',_vm.componentData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }